export interface FormFieldAttrsProps {
  id: string;
  hasError?: boolean;
}

export function getFormFieldAttrs({ id, hasError }: FormFieldAttrsProps) {
  return {
    'data-cy': id,
    'data-testid': id,
    ...(hasError && { 'data-error': 'true' }),
  };
}

export function getFormFieldErrorClasses(hasError?: boolean): string {
  return hasError ? 'border-red-500 focus:border-red-500 focus:ring-red-500/50' : '';
}
